import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setSession(r.data);
      return r.data;
    } catch (e) {
      setSession(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setSession(r.data);
    return r.data;
  };
  const register = async (body) => {
    const r = await api.post("/auth/register", body);
    setSession(r.data);
    return r.data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setSession(false);
  };

  return <AuthCtx.Provider value={{ session, setSession, refresh, login, register, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function homeFor(role) {
  if (role === "super_admin") return "/admin";
  if (role === "renter") return "/portal";
  if (role === "landlord") return "/landlord";
  return "/app";
}

export function useCurrency() {
  const { session } = useAuth();
  return session?.business?.currency || "GBP";
}
